import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { GuestService } from '../services/guest.service';
import { LanguageCode } from '../Models/WidgetSettingsModels';
import { DEFAULT_LANGUAGE_ID } from '../constants/commonenums';


@Pipe({
    name: 'formatSettingsDate',
    standalone: false
})
export class FormatSettingsDatePipe implements PipeTransform {
  constructor(private gs: GuestService){}

  transform(value: string | Date, format: string) {
    const language = this.gs.getLanguageIdFromUrl();
    const localeFromUrl = language
      ? LanguageCode[language.toLowerCase() as keyof typeof LanguageCode]
      : undefined;
    const localeFromSettings = this.gs.availableLanguages
      ? this.gs.findLocale(sessionStorage.getItem('languageId') || DEFAULT_LANGUAGE_ID)
      : undefined;
    const localeValue = localeFromUrl || localeFromSettings || 'en';

    return moment(new Date(value)).locale(localeValue).format(format.toUpperCase());
  }

}
